import AnnouncementsContainer from "./AnnouncementsContainer";

export { AnnouncementsContainer };
